/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const merchantSysSetting = {
  path: '/merchantSysSetting',
  component: Layout,
  alwaysShow: true,
  hidden: false,
  redirect: 'noredirect',
  name: 'merchantSysSetting',
  meta: {
    title: '系统设置',
    icon: 'system',
    roles: ['merchant']
  },
  children: [
    {
      path: 'resetLoginPassword',
      component: resolve => require(['@/views/common/resetPassword'], resolve),
      name: 'ResetLoginPassword',
      meta: { title: '修改登录密码', noCache: true }
    },
    {
      path: 'resetPayPassword',
      component: resolve => require(['@/views/merchant/sysSetting/resetPayPassword'], resolve),
      name: 'ResetPayPassword',
      meta: { title: '修改支付密码', noCache: false }
    },
    // {
    //   path: 'resetgoogleCode',
    //   component: resolve => require(['@/views/merchant/sysSetting/resetGoogleCode'], resolve),
    //   name: 'ResetgoogleCode',
    //   meta: { title: '谷歌身份验证', noCache: false }
    // },
    {
      path: 'bindIP',
      component: resolve => require(['@/views/merchant/sysSetting/bindIP'], resolve),
      name: 'BindIP',
      meta: { title: '登录IP白名单', noCache: false }
    }
  ]
}

export default merchantSysSetting



// WEBPACK FOOTER //
// ./src/router/merchant/merchantSysSetting.js